module.exports = __webpack_public_path__ + "img/hr-dry-tree-03.b187d7a8.png";